interface StepPagePosition {
  stepIdx: number
}

interface CalculateBlockQuizStartPageParams {
  lessonStartPage: number
  stepPages: readonly StepPagePosition[]
  hasBlockQuizzes: boolean
}

export function calculateBlockQuizStartPage({
  lessonStartPage,
  stepPages,
  hasBlockQuizzes,
}: CalculateBlockQuizStartPageParams): number | null {
  if (!hasBlockQuizzes) return null

  const firstBlockPageIndex = stepPages.findIndex(page => page.stepIdx === 1)
  if (firstBlockPageIndex < 0) return null

  return lessonStartPage + firstBlockPageIndex
}
